const blogListInit = () => {
  const mainPattern = document.querySelectorAll('.gg-blog-list');
  mainPattern.forEach((module) => {
    const inputAll = module.querySelector('#all');
    const inputs = module.querySelectorAll('input[type="radio"]');
    const articles = module.querySelectorAll('article');
    const pagination = module.querySelectorAll('.gravity-block-dynamic-boxes__pagination-link');
    const labelItem = module.querySelectorAll('.gravity-block-filters__radio-button-group label');

    let anyChecked = false;

    inputs.forEach(input => {
      if (input.checked) {
        anyChecked = true;
        return;
      }
    });

    if (!anyChecked) {
      if (inputAll) {
        inputAll.checked = true;
      }
    }

    labelItem.forEach(label => {
      label.addEventListener('click', () => {
      const loadingElement = module.querySelector('.gg-loading');
      if (loadingElement) {
        loadingElement.classList.add('show-loading');
        setTimeout(() => {
        loadingElement.classList.remove('show-loading');
        }, 1000);
      }
      });
    });

    articles.forEach((article, index) => {
      article.classList.add('fade-in-up', `delay-${index}`);

      const videoUrlElement = article.querySelector('.gravity-block-dynamic-boxes__post-video-url');
      if (videoUrlElement) {
        const parentElement = videoUrlElement.parentElement;
        parentElement.classList.add('button-play');
      }
    });

    const listPostsResult = module.querySelector('.posts-result__container');

    const observer = new MutationObserver(mutationsList => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(newNode => {
            const videoUrlElement = newNode.querySelector('.gravity-block-dynamic-boxes__post-video-url');
            if (videoUrlElement) {
              const parentElement = videoUrlElement.parentElement;
              parentElement.classList.add('button-play');
            }
          });
        }
      }
    });

    if (listPostsResult) {
      observer.observe(listPostsResult, {
        childList: true
      });
    }

    pagination.forEach(paginationLink => {
      paginationLink.addEventListener('click', () => {
        observer.disconnect();
        console.log(123)
        observer.observe(listPostsResult, {
          childList: true
        });
      });
    });
    const loadMore = module.querySelector('#load-more');
    articles.forEach((article, index) => {
      article.classList.add('fade-in-up', `delay-${index}`);
    });
    const parentElement = module.querySelector('.posts-result__container');
    const observerCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && !node.classList.contains('set-animation')) {
              const parent = node.parentElement;
              const childrenWithoutAnimation = Array.from(parent.children)
                .filter(child => !child.classList.contains('set-animation'));
              const index = childrenWithoutAnimation.indexOf(node);
              node.classList.add('fade-in-up', `delay-${index}`);
            }
          });
        }
      }
    };
    if (loadMore) {
      loadMore.addEventListener('click', () => {
        const newArticles = module.querySelectorAll('article');
        newArticles.forEach((article) => {
          if (article.classList.contains('fade-in-up') && !article.classList.contains('set-animation')) {
            article.classList.remove('fade-in-up');
            article.classList.add('set-animation');
          }
        });
        observer.observe(parentElement, { childList: true });
      });
    }
  });
  const searchField = document.querySelector('.gravity-block-filters__search-field');
  if (searchField) {
    const searchInput = searchField.querySelector('#filter-search-id');
    const searchButton = searchField.querySelector('.gravity-block-filters__submit');

    if (searchButton && searchInput) {
      searchButton.addEventListener('click', () => {
        searchInput.focus();
      });
    }
  }
}

blogListInit();
